/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Cc_All_ButtonInputs */



/**
* | output |
* | --- |
* | "CC All" |
*
* @param {Iconik_Publish_Cc_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_cc_all_button = /** @type {((inputs?: Iconik_Publish_Cc_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Cc_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CC tout")
	if (locale === "de") return /** @type {LocalizedString} */ ("CC Alle")
	if (locale === "it") return /** @type {LocalizedString} */ ("CC Tutti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("CC Все")
	if (locale === "es") return /** @type {LocalizedString} */ ("CC Todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("CC 所有")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてCC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसी ऑल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CC Todos")
	return /** @type {LocalizedString} */ ("CC All")
});